import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import landmarkData from './landmarks.json';
import taxi from '../belfast-cab-tour-planning-tool.png';
import './TourPlanningTool.css';
import '../../Styles.css';

const GOOGLE_MAPS_API_KEY = 'AIzaSyCn8QhTl33JJKaur3pQILy5xMTa-pqIxRA';

function TourPlanningTool() {
  const [landmarks, setLandmarks] = useState([]);
  const [selected, setSelected] = useState([]);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    setLandmarks(landmarkData);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleLandmark = (landmark) => {
    setSelected((prev) =>
      prev.some((item) => item.id === landmark.id)
        ? prev.filter((item) => item.id !== landmark.id)
        : [...prev, landmark]
    );
  };

  const calculateSummary = () => {
    const totalTime = selected.reduce((sum, item) => sum + item.timeRequired, 0);
    let estimatedCost = 0;
    if (selected.length > 0) {
      estimatedCost = 60;
      if (totalTime > 90) {
        estimatedCost += totalTime - 90;
      }
      estimatedCost = Math.ceil(estimatedCost / 10) * 10;
    }
    return { totalTime, estimatedCost };
  };
  
  const { totalTime, estimatedCost } = calculateSummary();
  

  return (
    <div className="tour-planning-tool">
      <header className="TourPlanningTool-header">
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%',
              transform: `translateY(-${scrollTop / 100}%)`,
            }}
          />
        </div>
        <h1 className="invisible">Plan Your Belfast Cab Tour</h1>
      </header>

      <div className="landmark-list">
        <h2>Available Landmarks</h2>
        {landmarks.map((landmark) => (
          <div key={landmark.id} className="landmark-card">
            <h3>{landmark.name}</h3>
            <p>{landmark.description}</p>
            <button
              onClick={() => toggleLandmark(landmark)}
              className={selected.some((item) => item.id === landmark.id) ? 'selected' : ''}
            >
              {selected.some((item) => item.id === landmark.id) ? 'Remove' : 'Add'}
            </button>
          </div>
        ))}
      </div>

      <div className="selected-itinerary">
        <h2>Your Itinerary</h2>
        {selected.length === 0 ? (
          <p>No landmarks selected yet.</p>
        ) : (
          <ul>
            {selected.map((item) => (
              <li key={item.id}>{item.name}</li>
            ))}
          </ul>
        )}
      </div>

      <div className="map-container">
        <h2>Tour Map</h2>
        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
          <GoogleMap
            center={{ lat: 54.6079, lng: -5.9264 }}
            zoom={12}
            mapContainerStyle={{ width: '100%', height: '600px' }}
          >
            {selected.map((landmark) => (
              <Marker
                key={landmark.id}
                position={{ lat: landmark.location.lat, lng: landmark.location.lng }}
              />
            ))}
          </GoogleMap>
        </LoadScript>
      </div>

      <div className="summary">
        <h2>Summary</h2>
        <p>
          *Based on pick-up / drop-off Belfast City Centre and 1-2 passengers - additional
          passengers (3/4/5/6/7) charged an extra £10 per passenger.
        </p>
        <br />
        <p><strong>Total Time: {totalTime} minutes</strong></p>
        <p><strong>Estimated Cost: £{estimatedCost}</strong></p>
      </div>

      <br />

      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto',
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{ color: '#fff', textDecoration: 'none' }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
}

export default TourPlanningTool;
